import {
  AccountBalance,
  AccountBalanceWallet,
  ArrowForwardIos,
  Assignment,
  BugReport,
  Contacts,
  Email,
  Event,
  ExitToApp,
  Group,
  GroupWork,
  History,
  HowToVote,
  LibraryBooks,
  LiveHelp,
  Menu as MenuIcon,
  MonetizationOn,
  Notifications,
  OpenInNew,
  Payment,
  PlaylistPlay,
  Policy,
  Poll,
  QuestionAnswer,
  Receipt,
  School,
  Settings,
  Store,
  Style,
  ViewList,
  ViewQuilt,
  WrapText,
} from "@mui/icons-material";
import {
  mdiAccount,
  mdiAccountSchool,
  mdiAccountTie,
  mdiBankTransfer,
  mdiBriefcasePlus,
  mdiCashMultiple,
  mdiCashRefund,
  mdiCashRegister,
  mdiClipboardOutline,
  mdiCounter,
  mdiGoogleClassroom,
  mdiPartyPopper,
  mdiPiggyBank,
  mdiSack,
  mdiSchool,
  mdiShape,
  mdiSignatureFreehand,
} from "@mdi/js";
import Icon from "@mdi/react";
import React from "react";

/**
 * Wrapper padrão pros ícones MDI.
 *
 * Usa `color="currentColor"` pra herdar a cor do <ListItemIcon> pai (controlado
 * pelo CSS do MenuDrawer/ItemIcon). Assim os MDI ficam consistentes com os
 * SvgIcons nativos do MUI — sem mais o "alguns brancos, outros cinza" causado
 * pelo color hardcoded `#5C93AD` antigo.
 */
function makeMdi(path) {
  // eslint-disable-next-line react/display-name
  return function MdiWrapper() {
    return <Icon path={path} size={1} color="currentColor" />;
  };
}

const PartyPopper = makeMdi(mdiPartyPopper);
const Formando = makeMdi(mdiAccountSchool);
const Formatura = makeMdi(mdiSchool);
const Sack = makeMdi(mdiSack);
const SignatureFreehand = makeMdi(mdiSignatureFreehand);
const GoogleClassroom = makeMdi(mdiGoogleClassroom);
const ClipBoard = makeMdi(mdiClipboardOutline);
const CashRegister = makeMdi(mdiCashRegister);
const CashMultiple = makeMdi(mdiCashMultiple);
const PiggyBank = makeMdi(mdiPiggyBank);
const CashRefund = makeMdi(mdiCashRefund);
const BankTransfer = makeMdi(mdiBankTransfer);
const BriefcasePlus = makeMdi(mdiBriefcasePlus);
const Account = makeMdi(mdiAccount);
const AccountTie = makeMdi(mdiAccountTie);
const Counter = makeMdi(mdiCounter);
const Shape = makeMdi(mdiShape);

const iconSet = {
  AccountBalanceWallet,
  AccountBalance,
  QuestionAnswer,
  MonetizationOn,
  Notifications,
  PlaylistPlay,
  LibraryBooks,
  Assignment,
  BugReport,
  OpenInNew,
  ExitToApp,
  ViewQuilt,
  HowToVote,
  GroupWork,
  Settings,
  WrapText,
  ViewList,
  LiveHelp,
  Contacts,
  Payment,
  Receipt,
  History,
  School,
  Email,
  Group,
  Event,
  Style,
  Store,
  Poll,
  Policy,
  Formando,
  Formatura,
};

const mdiIconSet = {
  SignatureFreehand,
  GoogleClassroom,
  BriefcasePlus,
  BankTransfer,
  CashRegister,
  CashMultiple,
  PartyPopper,
  AccountTie,
  CashRefund,
  PiggyBank,
  ClipBoard,
  Account,
  Counter,
  Shape,
  Sack,
};

function loadIcon(icon, hasSubmenu) {
  const MuiIcon = iconSet[icon];
  if (MuiIcon) {
    // Ícones MUI nativos (SvgIcon) herdam color via CSS naturalmente.
    return <MuiIcon />;
  }

  const MdiIcon = mdiIconSet[icon];
  if (MdiIcon) {
    // MDI wrappers usam `color="currentColor"` (makeMdi acima) — herdam tbm.
    return <MdiIcon />;
  }

  return hasSubmenu ? <MenuIcon /> : <ArrowForwardIos />;
}

function getMenuIcon(icon, hasSubmenu, noDefaultIcon) {
  if (icon) {
    if (typeof icon === "string") {
      return loadIcon(icon, hasSubmenu);
    }
    return icon;
  }
  if (noDefaultIcon) {
    return null;
  }
  return hasSubmenu ? <MenuIcon /> : <ArrowForwardIos />;
}

export default getMenuIcon;
